import { ICompletionsRentalUnitCost } from '../../interfaces/icompletions-rental-unit-cost';
import { GenSubSub } from '../gen-sub-sub';
import { PostStimMethod } from '../post-stim-method';
import { UnitOfMeasure } from '../unit-of-measure';

export class CompletionsRentalUnitCostBase {
  CompletionsRentalUnitCostId: number;
  BuildSheetActivityId: number;
  PostStimMethodId: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  LumpSum: number | null;
  GenSubSubId: number;
  Quantity: number | null;
  QuantityUom: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  GenSubSub?: GenSubSub;
  PostStimMethod?: PostStimMethod;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: ICompletionsRentalUnitCost) {
    if (item) {

      this.CompletionsRentalUnitCostId = item.CompletionsRentalUnitCostId;
      this.BuildSheetActivityId = item.BuildSheetActivityId;
      this.PostStimMethodId = item.PostStimMethodId;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.LumpSum = item.LumpSum;
      this.GenSubSubId = item.GenSubSubId;
      this.Quantity = item.Quantity;
      this.QuantityUom = item.QuantityUom;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.GenSubSub = new GenSubSub(item.GenSubSub);
      this.PostStimMethod = new PostStimMethod(item.PostStimMethod);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}